const router = function (permissions) {
  return ({
    path: 'lancamentoFaturamento',
    component: () => import('@/views/LancamentoFaturamento/LancamentoFaturasModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/LancamentoFaturamento/LancamentoFaturasList.vue'),
        meta: { permissions, title: 'Manutenção de Lançamentos do Faturamento' },
      },
    ],
  })
}

export default {
  router,
}
